import React from "react";
import { useTranslation } from "react-i18next";

const AssignedToTab: React.FC = () => {
  const { t } = useTranslation();
  const assignTo = [
    {
      evidenceId: "# EF3190123",
      registeredBy: {
        name: "Senay Daniel",
        role: t("police"),
        img: "person.png",
      },
      collectedDate: "January 12, 2024",
      itemDescription: t("assigned_personnel_sample_description"),
      name: "Physical Injuries from the Accused 1",
      size: "1.2 Mb",
    },
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start gap-4">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">
            {t("assigned_personnel")}
          </h2>
          <p className="text-gray-600 mt-1">
            {t("manage_assigned_personnel_for_case")}
          </p>
        </div>
      </div>

      {assignTo?.map((person, index) => (
        <div
          key={index}
          className="bg-white border border-gray-200 rounded-xl shadow-sm p-6"
        >
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
              <div className="w-12 h-12 bg-gray-200 rounded-lg flex items-center justify-center">
                <span className="text-gray-600">👤</span>
              </div>
              <div>
                <p className="font-semibold text-gray-900">
                  {person?.registeredBy?.name}
                </p>
                <p className="text-sm text-gray-600">
                  {person?.registeredBy?.role}
                </p>
              </div>
            </div>
            <div className="space-y-3">
              <div>
                <p className="text-sm font-medium text-gray-700">
                  {t("assigned_period")}
                </p>
                <p className="text-gray-600">{t("assigned_period_sample")}</p>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-700">Description</p>
                <p className="text-gray-600 text-sm">
                  {person?.itemDescription}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}

      <button
        className="w-full md:w-auto px-6 py-3 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors"
        onClick={() => {}}
      >
        {t("assign_delegate_prosecutor")}
      </button>
    </div>
  );
};

export default AssignedToTab;
